module.exports = __webpack_public_path__ + "img/pic_price_mortgage@2x.0c83a9d6.png";